module.exports = __webpack_public_path__ + "static/media/0110_IMG_LE_PLAFOND_KNAUF_ORGANIC_GRIS_PIERRE.98257ea4.webp";